import type { SVGProps } from "react";

export function IconBlackArrowsRightLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.75 20.25H18.75V21.75H10.75V28.6309L9.51172 27.5693L2.51172 21.5693L1.84766 21L2.51172 20.4307L9.51172 14.4307L10.75 13.3691V20.25ZM22.4883 4.43066L29.4883 10.4307L30.1523 11L29.4883 11.5693L22.4883 17.5693L21.25 18.6309V11.75H13.25V10.25H21.25V3.36914L22.4883 4.43066Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
